/**
 * @generated SignedSource<<371f5c39c572cbf6ed386daf970bd7c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Permission = "ADD" | "DEPLOY_POLICIES" | "EDIT" | "EDIT_ACL" | "LOGIN" | "REMOVE" | "VIEW" | "VIEW_ACL" | "VIEW_RESOURCES" | "%future added value";
export type UpdateUserInput = {
  displayName?: string | null | undefined;
  email?: string | null | undefined;
  key: number;
  name?: string | null | undefined;
  roles?: ReadonlyArray<string> | null | undefined;
};
export type UpdateUserMutation$variables = {
  input: UpdateUserInput;
};
export type UpdateUserMutation$data = {
  readonly updateUser: {
    readonly user: {
      readonly email: string | null | undefined;
      readonly key: number;
      readonly name: string | null | undefined;
      readonly roleAssignmentPrincipal: any;
      readonly roleAssignments: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly role: {
              readonly id: string;
              readonly name: string;
              readonly permissions: ReadonlyArray<Permission>;
            };
            readonly target: {
              readonly __typename: string;
              readonly displayName?: string;
              readonly id?: string;
              readonly name?: string;
              readonly roleAssignmentTarget: any;
            };
          };
        }> | null | undefined;
      };
    };
  } | null | undefined;
};
export type UpdateUserMutation = {
  response: UpdateUserMutation$data;
  variables: UpdateUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roleAssignmentPrincipal",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  (v4/*: any*/)
],
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 100
    }
  ],
  "concreteType": "RoleAssignmentConnection",
  "kind": "LinkedField",
  "name": "roleAssignments",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RoleAssignmentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoleAssignment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Role",
              "kind": "LinkedField",
              "name": "role",
              "plural": false,
              "selections": [
                (v6/*: any*/),
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "permissions",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "target",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "roleAssignmentTarget",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "displayName",
                      "storageKey": null
                    }
                  ],
                  "type": "RoleScope",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v7/*: any*/),
                  "type": "AccountGroup",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v7/*: any*/),
                  "type": "PolicyCollection",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v7/*: any*/),
                  "type": "RepositoryConfig",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v6/*: any*/)
                  ],
                  "type": "Node",
                  "abstractKey": "__isNode"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "roleAssignments(first:100)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserPayload",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserPayload",
        "kind": "LinkedField",
        "name": "updateUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v8/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8c40085cb9d16ba360ca7cad9c032dfd",
    "id": null,
    "metadata": {},
    "name": "UpdateUserMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateUserMutation(\n  $input: UpdateUserInput!\n) {\n  updateUser(input: $input) {\n    user {\n      email\n      key\n      name\n      roleAssignmentPrincipal\n      roleAssignments(first: 100) {\n        edges {\n          node {\n            id\n            role {\n              id\n              name\n              permissions\n            }\n            target {\n              __typename\n              roleAssignmentTarget\n              ... on RoleScope {\n                displayName\n              }\n              ... on AccountGroup {\n                name\n              }\n              ... on PolicyCollection {\n                name\n              }\n              ... on RepositoryConfig {\n                name\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "41151bb74ef5255673a56287fa15ef04";

export default node;
